const state = {
  one: null
}

const getters = {
  getHand: state => state.one
}

const mutations = {
  setHand (state, data) {
    state.one = data
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hands.js